import { callGet, callPost, callDelete, callPut } from "../integrations/calls";
import { REQ } from "../../libs/constants";

export const getVoucher = async (data, token) => {
  return await callPost(REQ.TANK_LORRY.GET_VOUCHER, data, token);
};

export const saveData = async (data, token) => {
  return await callPost(REQ.TANK_LORRY.SAVE_DATA, data, token);
};

export const getData = async (id, token) => {
  return await callGet(`${REQ.TANK_LORRY.GET_DATA}/${id}`, token);
};

export const getLorryReport = async (data, token) => {
  return await callPost(`${REQ.TANK_LORRY.GET_LORRY_DATA}`, data, token);
};

export const updateTankLorry = async (data, token) => {
  return await callPut(
    `${REQ.TANK_LORRY.UPDATE_TANK_LORRY}/${data.id}`,
    data,
    token
  );
};

export const deleteSingleTankLorry = async (id, token) => {
  return await callDelete(
    `${REQ.TANK_LORRY.DELETE_SINGLE_TANK_LORRY}/${id}`,
    {},
    token
  );
};

export const deleteTankLorry = async (id, token) => {
  return await callDelete(
    `${REQ.TANK_LORRY.DELETE_TANK_LORRY}/${id}`,
    {},
    token
  );
};
